import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiUser, FiMail } from "react-icons/fi";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from 'react-toastify';
import GoogleLogin from '@caranmegil/react-google-login';
import FacebookLogin from '@greatsumini/react-facebook-login';


//  components 
import InputPassword from "../InputPassword.component";

// images
import googleLogo from  "../../assets/images/google.png";
import fbLogo from "../../assets/images/facebook.png";
/**
 * 
 * Roles ************
 * 
 * Service Provider = 2      (Freelancer who done work)
 * Customer = 3              (Who Post Jobs)
 * 
 * Register from App = app
 */


// User / Customer 
export default function UserRegister({setUserScreen}) {
  
  let navigate = useNavigate();

  const [flag, setFlag] = useState('');
  const [error, setError] = useState('');
  const [latlong, setLatLong] = useState({});

  // get coordinates 
  // const getLatlong = (e) => {
  //   e.preventDefault();
  //   navigator.geolocation.getCurrentPosition(function(position) {
  //     console.log("Latitude is :", position.coords.latitude);
  //     console.log("Longitude is :", position.coords.longitude);
  //     setLatLong({
  //       lat: position.coords.latitude,
  //       lng: position.coords.longitude
  //     });
  //   });
  // }

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(function(position) {
      // console.log("Latitude is :", position.coords.latitude);
      // console.log("Longitude is :", position.coords.longitude);
      setLatLong({
        lat: position.coords.latitude,
        lng: position.coords.longitude
      });
    });
  }, []);

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      confirmPassword: "",
      mobileNumber: "",
      email: "",
    },
    validationSchema: Yup.object({
      username: Yup.string()
        .min("3", "Must have atleast 3 characters.")
        .required("Required"),
      password: Yup.string()
        .min("3", "Must have atleast 3 characters.")
        .required("Required"),
      confirmPassword: Yup.string().oneOf(
        [Yup.ref("password"), null],
        "Passwords must match"
      ),
      mobileNumber: Yup.number()
        .min("7", "Must have 7 characters.")
        .required("Required"),
      email: Yup.string().email().required("Required"),
    }),
    onSubmit: async (values) => {
      if (Object.keys(latlong).length > 0) {

        // registering service provider online
        await fetch(`${process.env.REACT_APP_BASE_URL}/api/register_user`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            user_name: values.username,
            email: values.email,
            password: values.password,
            confirm_password: values.confirmPassword,
            phone_number: values.mobileNumber,
            role: 3,            // User Type Customer Who Post Job
            user_type: "app",   // if user register from our app  
            address: "main road",
            latitude: latlong.lat,
            longitude: latlong.lng
          })
        })
          .then(r => r.json())
          .then(response => {
            // console.log(response);
            if (response.success) {
              toast.success(response.message);
              setTimeout(() => {
                return navigate("/signin", { replace: true });
              }, 2000);
            } else {
              toast.error(response.message);
            }
          });
      } else {
        toast.error("Please Allow Location to proceed.")
      }
    }
  });


  // Google Login Response 
  const responseGoogle = async (response) => {
    console.log(response);
    let email = response.profileObj.email;
    let name = response.profileObj.name;
    // let profile_image = response.profileObj.imageUrl;
    if (Object.keys(latlong).length > 0) {
      let googleData = new FormData;
      googleData.append("user_name", name);
      googleData.append("email", email);
      googleData.append("role", 3);
      googleData.append("user_type", "google");
      googleData.append("latitude", latlong.lat);
      googleData.append("longitude", latlong.lng);

      await fetch(`${process.env.REACT_APP_BASE_URL}/api/register_user`, {
        method: 'POST',
        body: googleData
      })
        .then(r => r.json())
        .then(response => {
          if (response.success) {
            toast.success(response.success);
            setTimeout(() => {
              return navigate("/signin", { replace: true });
            }, 2000);
          } else {
            toast.error(response.message);
          }
        });
    }
  }


  // Facebook Login Response 
  const responseFacebook = async (response) => {
    
    let email = response.email;
    let name = response.name;
    // let profile_image = response.profileObj.imageUrl;
    if (Object.keys(latlong).length > 0) {
      let facebookData = new FormData;
      facebookData.append("user_name", name);
      facebookData.append("email", email);
      facebookData.append("role", 3);
      facebookData.append("user_type", "facebook");
      facebookData.append("latitude", latlong.lat);
      facebookData.append("longitude", latlong.lng);

      await fetch(`${process.env.REACT_APP_BASE_URL}/api/register_user`, {
        method: 'POST',
        body: facebookData
      })
        .then(r => r.json())
        .then(response => {
          if (response.success) {
            toast.success(response.success);
            setTimeout(() => {
              return navigate("/signin", { replace: true });
            }, 2000);
          } else {
            toast.error(response.message);
          }
        });
    }
  }

  return (
    <>
      <ToastContainer />
      <form className="bds-themeform" onSubmit={formik.handleSubmit}>
        <fieldset>
          <div className="bds-themeform__wrap">
            <div className="form-group flex-column align-items-start">
              <div
                className={`bds-placeholderholder px-3 ${
                  formik.touched.username && formik.errors.username
                    ? "border border-danger"
                    : ""
                }`}
              >
                <FiUser />
                <input
                  name="username"
                  type="text"
                  className={`form-control bds-themeinput`}
                  placeholder="User Name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              <p className="m-0">
                {formik.touched.username && formik.errors.username ? (
                  <small className="text-danger">
                    {formik.errors.username}
                  </small>
                ) : null}
              </p>
            </div>
            <div className="form-group flex-column align-items-start">
              <div
                className={`bds-placeholderholder px-3 ${
                  formik.touched.mobileNumber && formik.errors.mobileNumber
                    ? "border border-danger"
                    : ""
                }`}
              >
                <FiUser />
                <input
                  name="mobileNumber"
                  type="number"
                  className={`form-control bds-themeinput`}
                  placeholder="Mobile Number"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              <p className="m-0">
                {formik.touched.mobileNumber && formik.errors.mobileNumber ? (
                  <small className="text-danger">
                    {formik.errors.mobileNumber}
                  </small>
                ) : null}
              </p>
            </div>
            <div className="form-group flex-column align-items-start">
              <InputPassword
                name="password"
                placeholder="Password"
                className="form-control bds-themeinput"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                errorclassName={
                  formik.touched.password && formik.errors.password
                    ? "border border-danger"
                    : ""
                }
              />
              <p className="m-0">
                {formik.touched.password && formik.errors.password ? (
                  <small className="text-danger">
                    {formik.errors.password}
                  </small>
                ) : null}
              </p>
            </div>
            <div className="form-group flex-column align-items-start">
              <InputPassword
                name="confirmPassword"
                placeholder="Confirm Password"
                className="form-control bds-themeinput"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                errorclassName={
                  formik.touched.confirmPassword &&
                  formik.errors.confirmPassword
                    ? "border border-danger"
                    : ""
                }
              />
              <p className="m-0">
                {formik.touched.confirmPassword &&
                formik.errors.confirmPassword ? (
                  <small className="text-danger">
                    {formik.errors.confirmPassword}
                  </small>
                ) : null}
              </p>
            </div>
            <div className="form-group flex-column align-items-start">
              <div
                className={`bds-placeholderholder px-3 ${
                  formik.touched.username && formik.errors.username
                    ? "border border-danger"
                    : ""
                }`}
              >
                <FiMail />
                <input
                  name="email"
                  type="email"
                  className={`form-control bds-themeinput`}
                  placeholder="Email Address"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              <p className="m-0">
                {formik.touched.email && formik.errors.email ? (
                  <small className="text-danger">{formik.errors.email}</small>
                ) : null}
              </p>
            </div>
            <div className="bds-popup-terms form-group">
              <button type="submit" name="submit" className="bds-btn-solid-lg">
                Sign Up
              </button>
            </div>
            {error && <p className='text-danger text-center w-100'><small>{error}</small></p>}
            {flag && <p className='text-success text-center w-100'><small>{flag}</small></p>}
            <div className="form-group">
              <div className="bds-optioanl-or">
                <span>OR</span>
              </div>
            </div>
            {/* Sign up with Google */}
            <GoogleLogin
              clientId={`${process.env.REACT_APP_GOOGLE_CLIENT_ID}`}
              render={renderProps => (
                <div className="bds-sginup-btn form-group">
                <button 
                  className="bds-btn-line-lefticon btn-signup"
                  onClick={renderProps.onClick} disabled={renderProps.disabled}
                >
                  <img
                    src={googleLogo}
                    alt="images"
                    width={30}
                    height={30}
                  />
                  <span className="ms-2">Signup with Google</span>
                </button>
              </div>
              )}
              buttonText="Login"
              onSuccess={responseGoogle}
              onFailure={responseGoogle}
              cookiePolicy={'single_host_origin'}
            />           
            <FacebookLogin
              appId={`${process.env.REACT_APP_FACEBOOK_CLIENT_ID}`}             
              onProfileSuccess={(response) => {
                responseFacebook(response);
              }}
              render={({ onClick }) => (
                // <CustomComponent onClick={onClick} onLogoutClick={logout} />
                <div className="bds-sginup-btn form-group">
                  <button 
                    className="bds-btn-line-lefticon btn-signup"
                    onClick={onClick} 
                  >
                    <img
                      src={fbLogo}
                      alt="images"
                      width={30}
                      height={30}
                    />
                    <span className="ms-2">Signup with Facebook</span>
                  </button>
                </div>
              )}
            />
           
            {/* Sign up with facebook */}
            {/* <div className="bds-sginup-btn form-group">
              <button className="bds-btn-line-lefticon btn-signup">
                <img
                  src={fbLogo}
                  alt="images"
                  width={30}
                  height={30}
                />
                <span className="ms-2">Signup with Facebook</span>
              </button>
            </div> */}


            <div className="form-group bds-lost-password w-auto">
              Already have an account?
              <Link to="/signin" className="ms-2">
                Signin
              </Link>
            </div>
          </div>
        </fieldset>
      </form>
    </>
  );
}
